module.exports = __webpack_public_path__ + "img/nav_stage.42337b48.svg";